"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Delete = function Delete(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    width: "24",
    height: "25",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.8,25H3.1c-0.3,0-0.5-0.2-0.5-0.5V3.6c0-0.3,0.2-0.5,0.5-0.5h16.7c0.3,0,0.5,0.2,0.5,0.5v20.9 C20.3,24.8,20.1,25,19.8,25z M3.6,24h15.7V4.1H3.6V24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.6,4.1H7.3C7,4.1,6.8,3.9,6.8,3.6V0.5C6.8,0.2,7,0,7.3,0h8.3c0.3,0,0.5,0.2,0.5,0.5v3.1C16.1,3.9,15.9,4.1,15.6,4.1z M7.8,3.1h7.3V1H7.8V3.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,4.1h-23C0.2,4.1,0,3.9,0,3.6s0.2-0.5,0.5-0.5h23c0.3,0,0.5,0.2,0.5,0.5S23.7,4.1,23.5,4.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.3,20.3c-0.3,0-0.5-0.2-0.5-0.5V7.3C6.8,7,7,6.8,7.3,6.8c0.3,0,0.5,0.2,0.5,0.5v12.5C7.8,20.1,7.6,20.3,7.3,20.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5,20.3c-0.3,0-0.5-0.2-0.5-0.5V7.3c0-0.3,0.2-0.5,0.5-0.5S12,7,12,7.3v12.5C12,20.1,11.7,20.3,11.5,20.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.6,20.3c-0.3,0-0.5-0.2-0.5-0.5V7.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v12.5C16.1,20.1,15.9,20.3,15.6,20.3z"
  }));
};

var _default = Delete;
exports["default"] = _default;